var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.report ? _c('card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading[_vm.loadingKey],
      expression: "loading[loadingKey]"
    }],
    attrs: {
      "title": _vm.report.name
    }
  }, [_vm.error ? _c('div', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), !_vm.collapsed ? _c('chart', {
    attrs: {
      "data": _vm.chartData,
      "type": _vm.report.chart_type
    }
  }) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }